import type { ReactNode } from 'react';
import { useBearAuthSession } from '@bear-auth/react';

import { AuthLoader } from '../AuthLoader';

export interface AuthResolvedProps {
    children: ReactNode;
}

export const AuthResolved = ({ children }: AuthResolvedProps) => {
    const { status } = useBearAuthSession();
    const authResolved = status === 'authenticated' || status === 'unauthenticated';

    if (!authResolved) {
        return <AuthLoader />;
    }

    return <>{children}</>;
};
